import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { NichoSection } from './components/NichoSection';
import { ServicesSection } from './components/ServicesSection';
import { DifferentiatorSection } from './components/DifferentiatorSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-petrol text-silver-light font-sans selection:bg-turquoise selection:text-petrol" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <NichoSection data-id="element-4" />
        <ServicesSection data-id="element-5" />
        <DifferentiatorSection data-id="element-6" />
        <FinalCTA data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}